import styled from '@emotion/styled'
import Form from 'react-bootstrap/Form'
import theme from '../../constants/theme'

const BaseRadio = styled(Form.Check)(() => ({
  fontSize: '12px',
  input: {
    backgroundColor: 'transparent',
    borderColor: theme.footerSpanColor,
    borderWidth: '2px',
    borderRadius: '6px',
    '&:checked': {
      backgroundColor: theme.talentinoBlue,
      borderColor: theme.talentinoBlue,
    },
  },
  label: {
    fontSize: '12px',
  },
}))

export default BaseRadio
